module.exports = __webpack_public_path__ + "static/media/mobileicon.c5a09ffd.svg";